import { StatusType } from "@/types/Status"
import { FieldIdentifier } from "@aws-sdk/client-connectcases"

export const AWS_CONNECT_CASES_CLIENT_CONFIG = {
  domainId: import.meta.env.SO_AWS_CONNECT_CASES_DOMAIN_ID,
  roleArn: import.meta.env.SO_AWS_CONNECT_CASES_ROLE_ARN,
  region: "eu-west-2",
} as const

interface IFieldId {
  dev: string
  prod: string
  readonly getId: () => string
}

class FieldId implements IFieldId {
  constructor(
    public dev: string,
    public prod: string,
  ) {}

  getId() {
    return __APP_ENV__ === "production" ? this.prod : this.dev
  }
}

/**
 * Map of field names to their corresponding AWS Connect Cases field IDs.
 *
 * These values are hardcoded for reliability since field IDs are stable UUIDs that
 * don't change once created in the Connect Cases domain. Using these constants
 * instead of dynamic field discovery provides better performance and reduces
 * potential runtime errors.
 */
export const AWS_CONNECT_CASES_FIELD_ID_MAP: Record<string, FieldId> = {
  accountNumber: new FieldId(
    "28b1d12a-3267-4503-adea-0710c0367d70",
    "728bce8e-c099-493b-9cac-7716f979e6d3",
  ),
} as const

export const AWS_CONNECT_CASES_FIELD_IDS: FieldIdentifier[] = Object.values(
  AWS_CONNECT_CASES_FIELD_ID_MAP,
).map((id) => ({ id: id.getId() }))

export const statusMap: Record<string, [StatusType, string]> = {
  open: ["caution", "Open"],
  "pending - cca": ["caution", "Pending CCA"],
  "pending - waiting on customer": ["caution", "Waiting on Customer"],
  "pending - 3rd party": ["caution", "Waiting on 3rd Party"],
  "tried to contact": ["caution", "Contact Attempted"],
  "pending - with specialist": ["caution", "With Specialist"],
  "pending - it servicedesk": ["caution", "IT servicedesk"],
  closed: ["default", "Closed"],
}
